import { createTheme } from '@material-ui/core/styles';
import { DARK_GREEN } from '../constants/ThemeColors';
import greenTheme from '../containers/themes/greenTheme';

export default (themeColor, applyTheme) => {
  switch (themeColor) {
    case DARK_GREEN: {
      applyTheme = createTheme(greenTheme);
      break;
    }
    default: createTheme(greenTheme);
  }
  return applyTheme;
};
